import {moreUser} from './more_user'
// User
const refreshTokenKey = 'issue-refresh-token';
const loginTimeKey = 'LoginTime';
const expiresInKey = 'expiresIn'
const angentKey = 'agentId';
const staffKey = 'staffId';
const applyTipsDialogKey = 'apply-tips-dialog';
const popupNoticeSessionKey = 'popup-notice-session-key';
const loginUpgradeNoticeKey = 'login-upgrade-notice-key';

export const getAgentId = () => sessionStorage.getItem(angentKey) || '';
export const setAgentId = (id: string) => sessionStorage.setItem(angentKey, id);
export const removeAgentId = () => sessionStorage.removeItem(angentKey);

export const setRefreshToken = (token: any) => sessionStorage.setItem(moreUser(refreshTokenKey), token);
export const getRefreshToken = () => sessionStorage.getItem(moreUser(refreshTokenKey)) || '';
export const removeRefreshToken = () => sessionStorage.removeItem(moreUser(refreshTokenKey));

export const setExpiresIn = (expiresIn: string) => sessionStorage.setItem(expiresInKey, expiresIn);
export const getExpiresIn = () => sessionStorage.getItem(expiresInKey) || '';
export const removeExpiresIn = () => sessionStorage.removeItem(expiresInKey);

export const setLoginTime = (expiresIn: string) => sessionStorage.setItem(loginTimeKey, expiresIn);
export const getLoginTime = () => sessionStorage.getItem(loginTimeKey) || '';
export const removeLoginTime = () => sessionStorage.removeItem(loginTimeKey);

export const getStaffId = () => sessionStorage.getItem(staffKey) || '';
export const setStaffId = (id: string) => sessionStorage.setItem(staffKey, id);
export const removeStaffId = () => sessionStorage.removeItem(staffKey);

export const setApplyTipsDialog = (value: any) => sessionStorage.setItem(applyTipsDialogKey, value);
export const getApplyTipsDialog = () => sessionStorage.getItem(applyTipsDialogKey) || '';
export const removeApplyTipsDialog = () => sessionStorage.removeItem(applyTipsDialogKey);

export const buildPopupNoticeSessionKey = (
  systemScope = 'GEAR',
  userId?: string | number,
  loginTime?: string
) => `${systemScope}:${userId || getStaffId() || 'anonymous'}:${loginTime || getLoginTime() || 'session'}`;
export const setPopupNoticeSessionKey = (value: string) => sessionStorage.setItem(popupNoticeSessionKey, value);
export const getPopupNoticeSessionKey = () => sessionStorage.getItem(popupNoticeSessionKey) || '';
export const removePopupNoticeSessionKey = () => sessionStorage.removeItem(popupNoticeSessionKey);

export const setLoginUpgradeNoticeKey = (value: string) => sessionStorage.setItem(loginUpgradeNoticeKey, value);
export const getLoginUpgradeNoticeKey = () => sessionStorage.getItem(loginUpgradeNoticeKey) || '';
export const removeLoginUpgradeNoticeKey = () => sessionStorage.removeItem(loginUpgradeNoticeKey);
